import { InjectionToken } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { FormTypeEnum } from './forms.types';
import {
  createRequiredStringControl,
  unwantedDomainValidator,
} from './forms.validators';

export const FORM_TYPE = new InjectionToken<FormTypeEnum>('FORM_TYPE');
export const API_SUBSCRIBE = '/api/subscribe';
export const API_FREE_TRIAL = '/api/free-trial';
export const FREE_TRIAL_FORM = new FormGroup({
  name: createRequiredStringControl(),
  surname: createRequiredStringControl(),
  email: createRequiredStringControl([
    Validators.email,
    unwantedDomainValidator(),
  ]),
  company: createRequiredStringControl(),
});

export const SUBSCRIBE_FORM = new FormGroup({
  email: createRequiredStringControl([Validators.email]),
});
